export const FIXED_VIDEO_HEIGHT = {
    height: '100vh',
    maxHeight: '100vh',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#000',
    overflow: 'hidden',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    maxWidth: '100vw'
} as const;